(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function() {
    class HeaderCartDrawer {
      constructor() {
        this.cart = [];
        this.drawer = document.querySelector('.ai-header-cart-drawer');
        this.overlay = document.querySelector('.ai-header-cart-overlay');
        this.cartItemsContainer = document.querySelector('.ai-header-cart-items');
        this.cartFooter = document.querySelector('.ai-header-cart-footer');
        this.emptyState = document.querySelector('.ai-header-cart-empty');
        this.cartIcon = document.getElementById('ai-cart-icon-bubble');

        if (this.cartIcon) {
          this.cartIcon.addEventListener('click', (e) => {
            e.preventDefault();
            this.openDrawer();
          });
        }

        // Move drawer to body to avoid z-index stacking context issues
        if (this.drawer && this.drawer.parentElement !== document.body) {
          document.body.appendChild(this.overlay);
          document.body.appendChild(this.drawer);
        }
        
        this.setupCartDrawer();
        this.loadCart();
      }

      setupCartDrawer() {
        const closeBtn = this.drawer.querySelector('.ai-header-cart-close');
        const continueBtn = this.emptyState.querySelector('.ai-header-cart-continue-btn');

        closeBtn.addEventListener('click', () => this.closeDrawer());
        this.overlay.addEventListener('click', () => this.closeDrawer());
        continueBtn.addEventListener('click', () => this.closeDrawer());
      }

      openDrawer() {
        this.drawer.classList.add('open');
        this.overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      }

      closeDrawer() {
        this.drawer.classList.remove('open');
        this.overlay.classList.remove('open');
        document.body.style.overflow = '';
      }

      loadCart() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
            this.cart = data.items;
            this.renderCart();
          })
          .catch(error => console.error('Error loading cart:', error));
      }

      formatMoney(cents) {
        return '₹' + (cents / 100).toFixed(2);
      }

      renderCart() {
        let total = 0;
        
        if (this.cart.length === 0) {
          this.emptyState.style.display = 'block';
          this.cartItemsContainer.style.display = 'none';
          this.cartFooter.style.display = 'none';
        } else {
          this.emptyState.style.display = 'none';
          this.cartItemsContainer.style.display = 'block';
          this.cartFooter.style.display = 'block';

          let cartHTML = '';
          this.cart.forEach(item => {
            total += item.final_line_price;
            cartHTML += `
              <div class="ai-header-cart-item" data-line-key="${item.key}">
                <img src="${item.image}" alt="${item.title}" class="ai-header-cart-item-image">
                <div class="ai-header-cart-item-details">
                  <div class="ai-header-cart-item-title">${item.product_title}</div>
                  <div class="ai-header-cart-item-variant">${item.variant_title || ''}</div>
                  <div class="ai-header-cart-item-price">${this.formatMoney(item.final_line_price)}</div>
                  <div class="ai-header-cart-item-actions">
                    <div class="ai-header-cart-quantity">
                      <button type="button" class="ai-header-cart-qty-btn" data-action="decrease" data-line-key="${item.key}">−</button>
                      <span class="ai-header-cart-qty-value">${item.quantity}</span>
                      <button type="button" class="ai-header-cart-qty-btn" data-action="increase" data-line-key="${item.key}">+</button>
                    </div>
                    <button type="button" class="ai-header-cart-remove-btn" data-line-key="${item.key}">🗑</button>
                  </div>
                </div>
              </div>
            `;
          });
          this.cartItemsContainer.innerHTML = cartHTML;
        }

        const checkoutBtn = this.cartFooter.querySelector('.ai-header-cart-checkout-btn');
        checkoutBtn.textContent = `PROCEED TO CHECKOUT - ${this.formatMoney(total)}`;

        this.setupCartActions();
      }

      setupCartActions() {
        const qtyButtons = this.cartItemsContainer.querySelectorAll('.ai-header-cart-qty-btn');
        const removeButtons = this.cartItemsContainer.querySelectorAll('.ai-header-cart-remove-btn');
        const checkoutBtn = this.cartFooter.querySelector('.ai-header-cart-checkout-btn');

        // Remove old listeners to prevent validation errors or duplication issues if re-run
        // In vanilla JS this is hard without cloning, but since we re-render InnerHTML, logic is fine.
        
        qtyButtons.forEach(button => {
          button.addEventListener('click', () => {
            const lineKey = button.dataset.lineKey;
            const action = button.dataset.action;
            const item = this.cart.find(i => i.key === lineKey);
            if (item) {
              const newQty = action === 'increase' ? item.quantity + 1 : item.quantity - 1;
              this.updateQuantity(lineKey, newQty);
            }
          });
        });

        removeButtons.forEach(button => {
          button.addEventListener('click', () => {
            const lineKey = button.dataset.lineKey;
            this.updateQuantity(lineKey, 0);
          });
        });
        
        checkoutBtn.onclick = () => {
          window.location.href = '/checkout';
        };
      }

      updateQuantity(lineKey, quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: quantity })
        })
        .then(response => response.json())
        .then(data => {
          this.loadCart();
        })
        .catch(error => console.error('Error updating cart:', error));
      }
    }

    // Initialize after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new HeaderCartDrawer());
    } else {
      new HeaderCartDrawer();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
